/**
 * Modal edit system component
 */

// React
import React, { FC } from 'react';

// Material
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Components
import EditSystemItem from './editSystemItem';

// Hooks
import { useEditSystems } from './useEditSystems';

// Common styles
import { ButtonUpdate, WrapperForm } from 'styles';

// Utils
import { DataSystemApplicationSettingCheck } from 'utils/types';

// Styled
const WrapperButton = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '80px',
});

// Type
type modalEditSystemProps = {
  open: boolean;
  handleClose: () => void;
  defaultValue: DataSystemApplicationSettingCheck | undefined;
  handleUpdateSuccess: () => Promise<void>;
};

// Component
const ModalEditSystem: FC<modalEditSystemProps> = ({
  open,
  handleClose,
  defaultValue,
  handleUpdateSuccess,
}) => {
  const { control, errors, handleUsageChange, handleSubmit, handleUpdate } = useEditSystems({
    handleClose,
    defaultValue,
    handleUpdateSuccess,
  });

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <WrapperForm onSubmit={handleSubmit(handleUpdate)}>
          <EditSystemItem control={control} errors={errors} handleUsageChange={handleUsageChange} />
          <WrapperButton>
            <ButtonUpdate
              onClick={handleClose}
              type="button"
              variant="outlined"
              sx={{ color: '#6EC8E2', border: '1px solid #6EC8E2' }}
            >
              戻る
            </ButtonUpdate>
            <ButtonUpdate type="submit" variant="contained">
              保存する
            </ButtonUpdate>
          </WrapperButton>
        </WrapperForm>
      </Modal>
    </div>
  );
};

export default ModalEditSystem;
